type DirtyDraft = {
  sections: Record<string, string>
}

type DirtyEdit = {
  messages: unknown[]
  sections: Record<string, string>
  structuredAra?: Record<string, unknown> | null
}

export function araDraftDirty(draft: DirtyDraft | null, edit: DirtyEdit | null): boolean {
  if (!draft || !edit) return false
  if (edit.messages.length > 0) return true
  if (Object.keys(draft.sections).some(key => edit.sections[key] !== draft.sections[key])) {
    return true
  }
  const structuredAra = edit.structuredAra ?? {}
  const overrides = (structuredAra.text_overrides as Record<string, string> | undefined) ?? {}
  if (Object.keys(overrides).length > 0) return true
  const chartOverrides =
    (structuredAra.chart_overrides as Record<string, unknown> | undefined) ?? {}
  return Object.keys(chartOverrides).length > 0
}

export function araPlantName(structuredAra: Record<string, unknown>): string {
  const plant = structuredAra.plant as { name?: unknown } | undefined
  return typeof plant?.name === 'string' ? plant.name.trim() : ''
}

/**
 * How many manual edits a full regeneration would discard (SCP-129): changed
 * or chat-inserted section bodies plus text and chart override keys. Inline
 * text edits land only in `text_overrides` (the render applies them), so the
 * counts don't double-book a single typed change; an AI proposal that rewrote
 * a section AND set overrides counts each artifact, erring high — the confirm
 * dialog states a loss, so over-announcing beats under-announcing.
 */
export function araManualEditCount(
  draft: DirtyDraft | null,
  edit: (DirtyEdit & { structuredAra?: Record<string, unknown> | null }) | null
): number {
  if (!draft || !edit) return 0
  let count = 0
  for (const [key, html] of Object.entries(edit.sections)) {
    if (draft.sections[key] !== html) count += 1
  }
  const overrides = (edit.structuredAra?.text_overrides as Record<string, unknown> | undefined) ?? {}
  count += Object.keys(overrides).length
  const chartOverrides =
    (edit.structuredAra?.chart_overrides as Record<string, unknown> | undefined) ?? {}
  count += Object.keys(chartOverrides).length
  return count
}
